export const GET_LANGUAGE = 'select language'
export const  GET_LANGUAGE_ON_LOAD = 'get language data on load'